<template>
  <div>
    <footer
      v-if="this.$route.name == 'frontendPackages'"
      class="footerbackground"
    >
      <v-row justify="center" align="center" class="px-5">
        <v-col cols="12" sm="12" md="6" lg="6" class="my-3">
          <v-img
            src="../../assets/Compeat-Logo-website.png"
            width="250px"
            height="50px"
          />
          <p class="mb-0 mt-2">
            &copy; 2023 |
            <a
              href="https://compeat.social/terms-and-conditions/"
              target="_blank"
              class="compeatsecondary--text"
              >Terms & Conditions</a
            >
            |
            <a
              href="https://compeat.social/privacy-policy/"
              target="_blank"
              class="compeatsecondary--text"
              >Privacy Policy</a
            >
            |
            <a
              href="https://compeat.social/resources-for-the-press/"
              target="_blank"
              class="compeatsecondary--text"
              >Resources For The Press </a
            >|
            <a
              href="https://compeat.social/in-the-news/"
              target="_blank"
              class="compeatsecondary--text"
              >In The News</a
            >
            |
            <a
              href="https://compeat.social/articles/"
              target="_blank"
              class="compeatsecondary--text"
              >Articles</a
            >
          </p>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          class="my-3 text-right hidden-sm-and-down"
        >
          <v-row justify="center" align="center">
            <v-col cols="12" class="text-right">
              <wordchanger />
            </v-col>
            <!-- <v-col cols="3" class="text-right">
              <v-btn large class="primary" href="#" target="_blank">
                <span class="white--text">Get Compeat-ing</span>
              </v-btn>
            </v-col> -->
            <v-col cols="12">
              <v-btn class="socialbuttons mx-1">
                <v-icon color="white"> mdi-facebook </v-icon>
              </v-btn>
              <v-btn class="socialbuttons mx-1">
                <v-icon color="white"> mdi-instagram </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </footer>
  </div>
</template>

<script>
import wordchanger from "../footercomponents/wordchanger.vue";
export default {
  components: {
    wordchanger,
  },
};
</script>

<style>
.footerbackground {
  background-color: #f3f3f3;
}

.socialbuttons {
  background-color: #333333 !important;
}

.v-btn:not(.v-btn--round).v-size--default {
  min-width: 45px !important;
}
</style>
